<template>
  <div class="flex flex-col gap-6">
    <!-- Page Header -->
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-2xl font-bold text-slate-800">科研诚信核查</h1>
        <p class="text-sm text-slate-500 mt-1">对申报书进行科研诚信核查，包括失信记录、撤稿记录、AIGC检测</p>
      </div>
      <div class="flex items-center gap-3">
        <span class="px-3 py-1.5 bg-blue-50 text-blue-600 rounded-full text-xs font-semibold">申报初审</span>
        <span class="px-3 py-1.5 bg-emerald-50 text-emerald-600 rounded-full text-xs font-semibold">已完成</span>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="glass-card rounded-3xl p-6">
      <!-- Section 1: Check Items -->
      <div class="mb-8">
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">核查项配置</h2>
        </div>
        <p class="text-sm text-slate-500 mb-4 ml-10">选择需要核查的项目，系统将对申报书进行多维度诚信核查</p>

        <div class="ml-10 space-y-3">
          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('dishonesty') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('dishonesty')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('dishonesty') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('dishonesty') ? 'text-blue-700' : 'text-slate-700'">失信记录核查</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('dishonesty') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">与国家科研诚信库比对，核查申请人是否存在违规记录</p>
            </div>
          </label>

          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('retraction') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('retraction')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('retraction') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('retraction') ? 'text-blue-700' : 'text-slate-700'">撤稿记录核查</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('retraction') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">基于申报书成员姓名、机构、论文名称，在被撤稿论文库中核查比对</p>
            </div>
          </label>

          <label class="flex items-center gap-4 p-4 rounded-xl cursor-pointer border-2 transition-all duration-300" 
                 :class="selectedChecks.includes('aigc') ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200 bg-white hover:border-blue-300'"
                 @click="toggleCheck('aigc')">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors"
                 :class="selectedChecks.includes('aigc') ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-500'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <h3 class="text-sm font-semibold transition-colors" 
                    :class="selectedChecks.includes('aigc') ? 'text-blue-700' : 'text-slate-700'">AIGC检测</h3>
                <div class="w-2 h-2 rounded-full transition-colors"
                     :class="selectedChecks.includes('aigc') ? 'bg-emerald-500' : 'bg-slate-300'"></div>
              </div>
              <p class="text-xs text-slate-500 mt-1">利用大语言模型检测工具分析，判断疑似AI生成比例</p>
            </div>
          </label>
        </div>
      </div>

      <!-- Section 2: Input -->
      <div class="mb-8">
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">申报书信息输入</h2>
        </div>
        <p class="text-sm text-slate-500 mb-4 ml-10">输入申报书内容或上传文件，进行科研诚信核查</p>

        <div class="ml-10">
          <div class="relative">
            <textarea
              v-model="declarationContent"
              class="premium-input w-full h-40 rounded-2xl p-5 text-sm leading-relaxed resize-none"
              placeholder="请粘贴申报书内容..."
            ></textarea>
            <div class="absolute bottom-4 right-4 text-xs text-slate-400">
              {{ declarationContent.length }} 字符
            </div>
          </div>

          <div class="mt-4 flex items-center gap-4">
            <button class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 hover:bg-slate-200 rounded-xl text-sm font-medium text-slate-600 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
              </svg>
              上传文件
            </button>
            <span class="text-xs text-slate-400">支持 PDF、DOCX 格式</span>
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <div class="flex justify-center">
        <button class="btn-action px-10 py-4 rounded-2xl text-white font-bold text-base flex items-center gap-3">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          启动诚信核查
        </button>
      </div>
    </div>

    <!-- Check Results -->
    <div class="glass-card rounded-3xl p-6">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </div>
          <h2 class="text-lg font-bold text-slate-800">核查结果</h2>
        </div>
        <button class="btn-export px-4 py-2 rounded-xl text-white text-sm font-medium flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
          </svg>
          导出报告
        </button>
      </div>

      <div class="space-y-4">
        <div class="p-4 bg-emerald-50 border border-emerald-200 rounded-xl">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <div class="flex-1">
              <h4 class="font-semibold text-emerald-800 text-sm">失信记录核查：无异常</h4>
              <p class="text-xs text-emerald-600 mt-1">经核查，申报书所有成员在国家科研诚信库中无违规记录</p>
            </div>
          </div>
        </div>

        <div class="p-4 bg-emerald-50 border border-emerald-200 rounded-xl">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <div class="flex-1">
              <h4 class="font-semibold text-emerald-800 text-sm">撤稿记录核查：无异常</h4>
              <p class="text-xs text-emerald-600 mt-1">经核查，申报书所有成员在被撤稿论文库中无记录</p>
            </div>
          </div>
        </div>

        <div class="p-4 bg-amber-50 border border-amber-200 rounded-xl">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-amber-500 flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="flex-1">
              <h4 class="font-semibold text-amber-800 text-sm">AIGC检测：一般疑似（52%）</h4>
              <p class="text-xs text-amber-600 mt-1">申报书部分内容疑似AI生成，建议人工复核</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResearchIntegrity',
  data() {
    return {
      selectedChecks: ['dishonesty', 'retraction', 'aigc'],
      declarationContent: ''
    }
  },
  methods: {
    toggleCheck(check) {
      const index = this.selectedChecks.indexOf(check)
      if (index > -1) {
        this.selectedChecks.splice(index, 1)
      } else {
        this.selectedChecks.push(check)
      }
    }
  }
}
</script>
